import cx from 'classnames'
import RAvatar from 'react-avatar'
import styles from './avatar.module.scss'

interface IAvatarProps {
  name: string
  src?: string
  className?: string
  isLarge?: boolean
  isMedium?: boolean
}

const Avatar = (props: IAvatarProps) => {
  const { src, name, className, isLarge, isMedium } = props
  const cls = cx(styles.avatar, className, { [styles.large]: isLarge, [styles.medium]: isMedium })

  return src ? (
    <img src={src} className={cls} alt="avatar" />
  ) : (
    <RAvatar name={name} className={cls} maxInitials={2} />
  )
}

export default Avatar
